module.exports = __webpack_public_path__ + "img/fushimi-HP-002.07dd02df.jpg";